import React, {memo, useCallback} from "react";
import {PlusMenu} from "./plusMenu/plusMenu";
import {useDispatch} from "react-redux";
import {cardEditorActions} from "../cardEditor.slice";
import { styled } from "styled-components";
import { ThemeProps } from "../../../styles/theme";
import { styleConstants } from "../../../styles/styleConstants";
import { uiActions } from "../../../ui/ui.slice";
import { SideMenu } from "../../../review/sideMenu/sideMenu";

const Root = styled.div<ThemeProps>`
    background-color: ${props => props.theme.secondaryBackground};
    border: ${props => props.theme.secondaryBorder} 1px solid;
    position: relative;
    height: ${styleConstants.actionBarHeight};
    width: 100%;
`;

const MenusLayer = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;
`;

const LeftSection = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const RightSection = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
`;

const Icon = styled.svg<ThemeProps>`
    height: ${styleConstants.actionBarIconSize};
    width:  ${styleConstants.actionBarIconSize};
    fill: ${props => props.theme.secondaryIcon};
    cursor: pointer;
`;

const PlusIcon = styled(Icon)`
    height: 50px;
    width: 50px;
`;

const EditorActionBarComponent: React.FC = memo(() => {
    const dispatch = useDispatch();
    const plusHandler = useCallback(() => {
        dispatch(cardEditorActions.openPlusMenu());
    }, [dispatch]);
    const openMenuHandler = useCallback(() => {
        dispatch(uiActions.openSideMenu());
    }, [dispatch]);

    return (
        <Root>
            <MenusLayer>
                <LeftSection>
                    <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" onClick={openMenuHandler}>
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
                    </Icon>
                </LeftSection>
                <RightSection>
                    <PlusIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                        onClick={plusHandler}>
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                    </PlusIcon>
                </RightSection>
            </MenusLayer>
            <PlusMenu/>
            <SideMenu />
        </Root>
    );
});

EditorActionBarComponent.displayName = 'EditorActionBarComponent';

export { EditorActionBarComponent as EditorActionBar };
